export default {
    _prefix: "qualityForm.commonQuestionComponents",
    labels: {
        defaultAnswerText: "[Answer Text Here]",
        multipleSelectPlaceholder: "Select answer(s)...",
        multipleSelectAriaLabel: "Multiple Select Answer Options",
        clearAnswer: "Clear Answer",
        addComments: "Add Comments",
        addCommentsInTextBox: "Add Comments ...",
        clearComments: "Clear Comments",
        commentCharLimitExceeded: (data: { characterLimit: number }) =>
            "Comment must not exceed {{characterLimit}} characters",
        na: "N/A",
        assistedAnswer: "Assisted Answer",
        assistedSelection: "Assisted Selection",
        aiSuggestedAnswer: "AI Suggested",
        invalidInput: "Invalid Input",
        correct: "Correct",
        incorrect: "Incorrect",
        partial: "Partial",
    },
    errors: {
        fieldRequired: "This field is required.",
    },
};
